import { useLoggedInUser } from "./logged-in-user";

export function useIsLoggedInUser() {
  const { status, data, error } = useLoggedInUser();

  if ( status === 'loading' ) {
    return {
      status: 'loading', 
      data: false,
    }
  }
  
  if ( status === 'error' ) {
    const statusCode = error?.response?.status ?? 0;
    let status = 'error';

    if (statusCode === 401 || statusCode === 403) {
      status = 'success';      
    }
    
    return {
      status: status, 
      data: false,
      error: error
    }
  }

  let retVal = (data?.id > 0) ? true : false;

  return {
    status: 'success',
    data: retVal
  }
}